<template>
  <b-modal ref="scan-modal" title="Selectionner une station" hide-footer >
    <div class="container-fluid my-3">
      <div class="row">
        <div v-for="(station, index) in workstationList"
             :key="index"
             class="col-12 col-md-4 my-2">
          <div @click="selectWorkstation(station)"
               class="clickable wk-scan-card"
               :class="{'selected-station': currentWorkstation === station,
                         'red-bin-wk': station.name === 'Red bin',
                         'red-bin-selected': (station.name === 'Red bin' && currentWorkstation.name === 'Red bin')}">
            {{ station.name }}
          </div>
        </div>
      </div>

      <div>
        <div class="row justify-content-center mt-4">
          <b-button
            variant="outline-danger"
            @click="cancel()"
            class="mr-5"
            >Annuler</b-button
          >
          <b-button
            type="submit"
            variant="primary"
            :disabled="!workstationIsSelected"
            @click="scanDocument"
            >
            Valider
          </b-button>
        </div>
      </div>


    </div>
  </b-modal>
</template>
<script>
import server from '../api/server.vue'
import _ from 'lodash'

export default {
  name: 'scan-modal',
  props: [],
  data() {
    return {
      currentWorkstation: {},
      flux: '',
      code: '',
      workstationList: [],
      workstationIsSelected: false,
      oldWorkstation: null,
    }
  },
  methods: {
    selectWorkstation (station) {
      this.currentWorkstation = station
      this.workstationIsSelected = true
    },
    scanDocument () {
      const params = { code: this.code, workstation: this.currentWorkstation.name, loop: this.flux }
      server.scanDocument(params).then((result) => {
        params['oldWorkstation'] = this.oldWorkstation
        this.$emit('document-scan-modal-close', params)
        this.hideModal()
      })
    },
    resetData () {
      this.workstationIsSelected = false
      this.flux = ''
      this.code = ''
      this.currentWorkstation = {}
    },
    hideModal () {
      this.resetData()
      this.$refs['scan-modal'].hide()
    },
    cancel () {
      this.$emit('cancel-modal', this.code)
      this.hideModal()
    },
    showModal (document) {
      this.flux = document.flux
      this.code = document.code
      server.getWorkstations(this.flux).then((result) => {
        this.workstationList = result.data
        this.oldWorkstation = document.workstation
        this.currentWorkstation =  this.workstationList.find((wk_obj) => {
          return wk_obj.name === this.oldWorkstation
        })

        this.$refs['scan-modal'].show()
      })
    },
  },
  watch: {}
}
</script>

<style lang="scss">
  .wk-scan-card {
    background-color: var(--a-light-blue);
    color: white;
    text-align: center;
    padding: 1rem;
    border-radius: 3px;
    height: 100%;

    &:hover, &.selected-station {
      background-color: var(--a-dark-blue)
    }

    &.red-bin-wk {
      background-color: var(--a-light-red)
    }

    &.red-bin-wk:hover, &.red-bin-selected {
      background-color: var(--a-dark-red)
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/ScanModal.vue